import { render, staticRenderFns } from "./OrderTypeSelect.vue?vue&type=template&id=72695d1e"
import script from "./OrderTypeSelect.vue?vue&type=script&lang=js"
export * from "./OrderTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports